<a
  class="menu-item-btn"
  [attr.href]="link || null"
  [attr.target]="link ? target : null"
  draggable="false"
  [class.hover-effect]="hoverEffect"
  [class]="type"
>
  <rt-icon
    class="right-icon"
    [name]="icon"
    [size]="iconSize"
    [colorToken]="$any(isActive ? 'colorIconPrimaryDefault' : 'colorIconStrongDefault')"
  ></rt-icon>
  @if (!!buttonText) {
    <rt-truncate variant="default">
      <span class="btn-text" [class.has-text]="!!buttonText">{{ buttonText }}</span>
    </rt-truncate>
  }

  @if (rightIcon) {
    <rt-icon
      class="left-icon"
      [name]="rightIcon"
      [size]="iconSize"
      colorToken="colorIconStrongDefault"
    ></rt-icon>
  }

  <div class="indicator">
    <ng-content select="[indicator-content]"></ng-content>
  </div>
  <div class="container-walkthrough-tooltip-item-anchor">
    <ng-content select="[walkthrough-tooltip-item-anchor]"></ng-content>
  </div>
  <div class="check-icon">
    <ng-content select="[check-icon]"></ng-content>
  </div>
  <div class="menu-divider">
    <ng-content select="[menu-divider]"></ng-content>
  </div>
</a>
